export default "__VITE_ASSET__DbIiQohx__"